import React from "react";
import { Text } from "react-konva";

const DrawnText = ({
  text,
  textIndex,
  textProps,
  tool,
  color,
  isSelected,
  updateTexts,
  onSelect,
  onChange,
  stageScale,
  // x,
  // y,
  stage,
}) => {
  const textRef = React.useRef();

  const onMouseEnter = (event) => {
    if (isSelected) {
      event.target.getStage().container().style.cursor = "move";
    }
    if (!isSelected) {
      event.target.getStage().container().style.cursor = "pointer";
    }
  };

  const onMouseLeave = (event) => {
    event.target.getStage().container().style.cursor = "default";
  };

  const handleTextDblClick = (e) => {
    const textNode = textRef.current;
    //Hide text and transformer
    textRef.current.hide();

    // create textarea over canvas with absolute position
    // first we need to find position for textarea
    // how to find it?

    // at first lets find position of text node relative to the stage:
    var textPosition = textRef.current.getAbsolutePosition();

    // then lets find position of stage container on the page:
    var stageBox = stage.container().getBoundingClientRect();

    // so position of textarea will be the sum of positions above:
    var areaPosition = {
      x: stageBox.left + textPosition.x,
      y: stageBox.top + textPosition.y,
    };

    // create textarea and style it
    var textarea = document.createElement("textarea");
    document.body.appendChild(textarea);

    // apply many styles to match text on canvas as close as possible
    // remember that text rendering on canvas and on the textarea can be different
    // and sometimes it is hard to make it 100% the same. But we will try...
    textarea.value = textNode.text();
    textarea.style.position = "absolute";
    textarea.style.top = areaPosition.y + "px";
    textarea.style.left = areaPosition.x + "px";
    textarea.style.width = textNode.width() - textNode.padding() * 2 + "px";
    textarea.style.height =
      textNode.height() - textNode.padding() * 2 + 5 + "px";
    textarea.style.fontSize = textNode.fontSize() * stageScale + "px";
    textarea.style.border = "none";
    textarea.style.padding = "0px";
    textarea.style.margin = "0px";
    textarea.style.overflow = "hidden";
    textarea.style.background = "none";
    textarea.style.outline = "none";
    textarea.style.resize = "none";
    textarea.style.lineHeight = textNode.lineHeight();
    textarea.style.fontFamily = textNode.fontFamily();
    textarea.style.transformOrigin = "left top";
    textarea.style.textAlign = textNode.align();
    textarea.style.color = textNode.fill();
    var rotation = textNode.rotation();

    var transform = "";

    if (rotation) {
      transform += "rotateZ(" + rotation + "deg)";
    }

    var px = 0;
    transform += "translateY(-" + px + "px)";

    textarea.style.transform = transform;

    // reset height
    textarea.style.height = "auto";
    // after browsers resized it we can set actual value
    textarea.style.height = textarea.scrollHeight + 3 + "px";

    textarea.focus();

    function removeTextareaFromClick() {
      textarea.parentNode.removeChild(textarea);
      window.removeEventListener("click", handleOutsideClick);
      textNode.show();
    }

    function removeTextareaFromEnter() {
      textarea.parentNode.removeChild(textarea);
      window.removeEventListener("click", handleOutsideClick);
      textNode.show();
    }

    function setTextareaWidth(newWidth) {
      if (!newWidth) {
        // set width for placeholder
        newWidth = textNode.placeholder.length * textNode.fontSize();
      }
      textarea.style.width = newWidth + "px";
    }

    textarea.addEventListener("keydown", function (e) {
      // hide on enter
      // but don't hide on shift + enter
      if (e.keyCode === 13 && !e.shiftKey) {
        textNode.text(textarea.value);
        updateTexts(textIndex, textarea.value);
        removeTextareaFromEnter();
      }
      // on esc do not set value back to node
      if (e.keyCode === 27) {
        removeTextareaFromEnter();
      }
    });

    textarea.addEventListener("keydown", function (e) {
      var scale = textNode.getAbsoluteScale().x;
      setTextareaWidth(textNode.width() * scale);
      textarea.style.height = "auto";
      textarea.style.height =
        textarea.scrollHeight + textNode.fontSize() + "px";
    });

    function handleOutsideClick(e) {
      if (e.target !== textarea) {
        textNode.text(textarea.value);
        updateTexts(textIndex, textarea.value);
        removeTextareaFromClick();
      }
    }
    setTimeout(() => {
      window.addEventListener("click", handleOutsideClick);
    });
  };

  return (
    <React.Fragment>
      <Text
        fontSize={20}
        color={color}
        fill={color}
        // stroke={color}
        tool="text"
        name="selectable"
        onClick={onSelect}
        ref={textRef}
        draggable={tool === "none" ? true : false}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        text={text}
        wrap="word"
        onDblClick={(e) => handleTextDblClick(e)}
        {...textProps}
        onDragEnd={(event) => {
          onChange({
            ...textProps,
            x: event.currentTarget.x(),
            y: event.currentTarget.y(),
          });
        }}
        onTransformEnd={(event) => {
          // transformer is changing scale of the node
          // and NOT its width or height
          // but in the store we have only width and height
          // to match the data better we will reset scale on transform end
          const node = textRef.current;
          const scaleX = node.scaleX();
          const scaleY = node.scaleY();

          // we will reset it back
          node.scaleX(1);
          node.scaleY(1);
          onChange({
            ...textProps,
            x: node.x(),
            y: node.y(),
            rotation: node.attrs.rotation,
            // fontSize: node.attrs.fontSize * scaleX,
            // set minimal value
            width: Math.max(5, node.width() * scaleX),
            height: Math.max(node.height() * scaleY),
          });
        }}
      />
    </React.Fragment>
  );
};

export default DrawnText;
